export function InterpunctedText(textArray: string[]) {
    return textArray.join(' · ');
}
